import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Monogram } from "@/components/Monogram";
import { WA_FINAL, WA_NUMBER_DISPLAY } from "@/lib/site";

const FinalCta = () => (
    <section
        data-testid="final-cta-section"
        className="relative py-28 sm:py-36 overflow-hidden bg-[#050506] border-t border-line/60"
    >
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_60%_60%_at_50%_100%,rgba(212,175,55,0.14),transparent_70%)]" />
        <div className="absolute inset-0 bg-grid opacity-60 [mask-image:radial-gradient(ellipse_60%_60%_at_50%_50%,black,transparent)]" />
        <Monogram className="absolute left-1/2 -translate-x-1/2 -bottom-24 w-[380px] h-[380px] opacity-[0.03] pointer-events-none" />

        <div className="relative mx-auto max-w-4xl px-5 sm:px-8 flex flex-col items-center gap-9 text-center">
            <Reveal>
                <span className="rule-gold w-32" />
            </Reveal>
            <Reveal delay={0.08}>
                <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-ink leading-[1.12]">
                    Seu negócio já existe.
                    <br />
                    <span className="text-gold-grad">Agora vamos melhorar a forma como ele aparece.</span>
                </h2>
            </Reveal>
            <Reveal delay={0.16}>
                <p className="text-base sm:text-lg text-ink2 leading-relaxed max-w-2xl">
                    Conte para a SETH o que sua empresa precisa e descubra qual solução faz mais
                    sentido para o seu momento.
                </p>
            </Reveal>
            <Reveal delay={0.24} className="flex flex-col items-center gap-5">
                <a
                    href={WA_FINAL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="final-cta-button"
                    className="btn-gold relative inline-flex items-center justify-center gap-2.5 rounded-full px-9 py-4 text-base font-semibold tracking-wide"
                >
                    Falar com a SETH
                    <ArrowUpRight size={18} />
                </a>
                <a
                    href={WA_FINAL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="final-cta-phone"
                    className="font-mono2 text-sm tracking-[0.15em] text-ink3 hover:text-gold transition-colors duration-300"
                >
                    {WA_NUMBER_DISPLAY}
                </a>
            </Reveal>
        </div>
    </section>
);

export default FinalCta;
